import { ErrorBoundary } from 'react-error-boundary';
import { Heading } from 'yoso';
import { LoginSecurity } from '~/components/Auth/Login/Security/LoginSecurity';
import { Translation } from '~/components/I18n';
import { MissionExploreErrorFallback } from '~/components/Mission/Explore/Error/MissionExploreErrorFallback';
import { MissionExploreList } from '~/components/Mission/Explore/List/MissionExploreList';
import { useMissionPageParams } from '~/components/Mission/Mission.hooks';
import { MissionTabNav } from '~/components/Mission/Nav/MissionTabNav';
import styles from './MissionExplore.module.scss';

export const MissionExplore = () => {
  const { status } = useMissionPageParams();

  return (
    <div className={styles.root}>
      <Heading className={styles.title} level={5}>
        <Translation name="citizen_mission_list_title" />
      </Heading>
      <p className={styles.description}>
        <Translation name="citizen_mission_status_desc" />
      </p>
      <MissionTabNav className={styles.tabNav} />
      <ErrorBoundary resetKeys={[status]} FallbackComponent={MissionExploreErrorFallback}>
        <LoginSecurity>
          <MissionExploreList className={styles.list} />
        </LoginSecurity>
      </ErrorBoundary>
    </div>
  );
};
